// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"fe185e68","553":"82bf9843","977":"fe1e3ed9"}[chunkId] + ".chunk.js";
};